import { tagsApi } from "../../services/tags";

export const transformTagsResponse = (tagIds: string[]) => {
  const { data: serverTags = [] } = tagsApi.useGetTagsQuery();
  const { data: categories = [] } = tagsApi.useGetTagCategoriesQuery();
  if (!tagIds) return {};

  const uniqueTagIds = [...new Set(tagIds)];

  return uniqueTagIds.reduce(
    (acc, tagId) => {
      const tag = serverTags.find((t) => t.tagId === tagId);
      if (!tag) return acc;

      const category = categories.find((c) => c.tagCategoryId === tag.tagCategoryId);
      if (!category) return acc;

      const categoryName = category.name;

      if (!acc[categoryName]) {
        acc[categoryName] = [];
      }

      acc[categoryName].push({
        id: tagId,
        name: tag.name || "Unknown",
      });

      return acc;
    },
    {} as Record<string, Array<{ id: string; name: string }>>
  );
};
